// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --background: var(--input-background);
  --border-width: 0px !important;
  border: none !important;
  --border-radius: 12px !important;
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-input {
  --border: none !important;
  color: #fff;
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent ;
}

.privacy {
  font-size: 12px;
  color: #fff;
}
.privacy ion-button {
  padding: 0px;
  color: var(--accent-color);
  text-transform: capitalize;
}

.privacy-btn {
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}

ion-checkbox {
  margin-left: 0px;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: #fff;
  font-family: AppFont, sans-serif;
}
.input-age ion-input:first-child {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}
.input-age ion-input:last-child {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: var(--main-background);
  color: #fff;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal .header-top {
  display: flex;
  align-items: center;
  padding: 20px 20px 0;
}
@media (min-width: 991px) {
  .wrapper-modal .header-top {
    padding: 30px 30px 0;
  }
}
.wrapper-modal .header-top .back-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.wrapper-modal .title-text {
  flex-grow: 1;
  font-family: AppFontMedium, sans-serif;
  font-size: 18px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--accent-color);
  margin: 0 16px 0 0;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-size: 24px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 16px;
  }
}
.wrapper-modal .header-block {
  padding: 10px;
  flex-grow: 1;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 30px 30px 0px;
  }
}
.wrapper-modal .footer-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-modal .footer-section .delete-user {
  width: -moz-fit-content;
  width: fit-content;
  height: 36px;
  padding: 10px 15px;
  border: 1px solid #811B0F;
  border-radius: 26px;
  color: #e86a5c;
  text-transform: uppercase;
  margin-bottom: 30px;
  font-family: AppFontMedium;
  font-size: 14px;
  letter-spacing: 0.08em;
  cursor: pointer;
}

.update-user {
  padding: 10px;
  width: 100%;
  border-top: 0.5px solid rgba(255, 255, 255, 0.2);
}
.update-user ion-button {
  width: 100%;
}

.update-btn {
  --background: var(--accent-color);
  color: #fff;
  width: 100%;
}
.update-btn:hover {
  --background: #a9715c;
}`, "",{"version":3,"sources":["webpack://./src/app/components/user-data-modal/user-data-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAGA;EACE,qCAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;AAAF;AAEE;EACE,2BAAA;AAAJ;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,gCAAA;AAAF;;AAEA;EACE,kBAAA;EACA,0BAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF;AAAE;EACE,YAAA;EACA,0BAAA;EACA,0BAAA;AAEJ;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAEF;;AACA;EACE,gBAAA;AAEF;AADE;EACE,kBAAA;AAGJ;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,oCAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AAEF;ACnEE;ED4DF;IAQI,4BAAA;IACA,eAAA;EAGF;AACF;;AACE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AAEJ;AAAE;EACE,gDAAA;AAEJ;AAAE;EACE,+CAAA;AAEJ;;AACA;EACE,yBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,YAAA;EACA,mBAAA;AAGF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAIF;AAHE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAKJ;AAJI;EACE,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAMN;;AAFA;EAOE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;AADF;AChIE;EDkHF;IAEI,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAgBF;AACF;AALE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAOJ;ACnJE;EDyIA;IAMI,oBAAA;EAQJ;AACF;AANI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAQN;AAJE;EACE,YAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AAMJ;ACtKE;EDyJA;IAUI,eAAA;EAOJ;AACF;AALE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;AAOJ;ACnLE;EDsKA;IAQI,eAAA;EASJ;AACF;AAPE;EACE,aAAA;EAIA,YAAA;AAMJ;AC5LE;EDiLA;IAGI,sBAAA;EAYJ;AACF;AATE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAWJ;AAVI;EACE,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EAEA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AAWN;;AAPA;EACE,aAAA;EACA,WAAA;EACA,gDAAA;AAUF;AATE;EACE,WAAA;AAWJ;;AAPA;EACE,iCAAA;EACA,WAAA;EACA,WAAA;AAUF;AATE;EACE,qBAAA;AAWJ","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\nion-item {\n  --background: var(--input-background);\n  --border-width: 0px !important;\n  border: none !important;\n  --border-radius: 12px !important;\n  margin-bottom: 12px;\n\n  &.no-line {\n    --border-color: transparent;\n  }\n}\nion-input {\n  --border: none !important;\n  color: #fff;\n  font-family: AppFont, sans-serif;\n}\n.no-line {\n  border-bottom: 0px;\n  --background: transparent\n}\n\n.privacy{\n  font-size: 12px;\n  color: #fff;\n  ion-button {\n    padding: 0px;\n    color: var(--accent-color);\n    text-transform: capitalize;\n  }\n}\n.privacy-btn{\n  margin-left: 5px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\n.stacked {\n  position: relative;\n  top: -10px;\n  left: 0%;\n  z-index: 2;\n}\n\n.terms {\n  margin-left: 0px;\n  ion-checkbox {\n    margin-right: 10px;\n  }\n}\n\nion-checkbox {\n  margin-left: 0px;\n}\n\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n\n  @include mobile {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n  }\n}\n\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: #fff;\n    font-family: AppFont, sans-serif;\n  }\n  ion-input:first-child {\n    border-right: 1px solid rgba(255, 255, 255, 0.2);\n  }\n  ion-input:last-child {\n    border-left: 1px solid rgba(255, 255, 255, 0.2);\n  }\n}\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  ion-button {\n    width: 100%;\n    margin: 10px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    p {\n      margin-top: 5px;\n      font-family: AppFontBold, sans-serif;\n      color: white;\n      width: 75%;\n    }\n  }\n}\n.wrapper-modal {\n  @include mobile {\n    margin-top: 25px;\n    border-bottom: none;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n  border-radius: 26px;\n  height: 100%;\n  position: relative;\n  overflow: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  background: var(--main-background);\n  color: #fff;\n\n  .header-top {\n    display: flex;\n    align-items: center;\n    padding: 20px 20px 0;\n\n    @include desktop {\n      padding: 30px 30px 0;\n    }\n\n    .back-icon {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n    }\n  }\n\n  .title-text {\n    flex-grow: 1;\n    font-family: AppFontMedium, sans-serif;\n    font-size: 18px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    color: var(--accent-color);\n    margin: 0 16px 0 0;\n\n    @include desktop {\n      font-size: 24px;\n    }\n  }\n  .subtitle-text {\n    width: 100%;\n    text-align: center;\n    color: #fff;\n    text-transform: uppercase;\n    font-family: AppFont, sans-serif;\n    padding: 10px;\n    @include desktop {\n      font-size: 16px;\n    }\n  }\n  .header-block {\n    padding: 10px;\n    @include desktop {\n      padding: 30px 30px 0px;\n    }\n    flex-grow: 1;\n  }\n  .footer-section {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .delete-user {\n      width: fit-content;\n      height: 36px;\n      padding: 10px 15px;\n      border: 1px solid #811B0F;\n      border-radius: 26px;\n      color: #e86a5c;\n      text-transform: uppercase;\n      margin-bottom: 30px;\n\n      font-family: AppFontMedium;\n      font-size: 14px;\n      letter-spacing: 0.08em;\n      cursor: pointer;\n    }\n  }\n}\n.update-user {\n  padding: 10px;\n  width: 100%;\n  border-top: 0.5px solid rgba(255, 255, 255, 0.2);\n  ion-button {\n    width: 100%;\n  }\n}\n\n.update-btn {\n  --background: var(--accent-color);\n  color: #fff;\n  width: 100%;\n  &:hover {\n    --background: #a9715c;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
